import loadable from '@nordvpn/teams.core/lib/tools/loadable';
// Replaces the legacy CustomPlansList / PartnerPlansList behind PackagesListRedesign.
export var PlansList = loadable(function () {
    return import(/* webpackPrefetch: true */ './pages/PlansList');
});
